(function() {
  function initConfigurator(configurator) {
    // Guard: skip if missing or already initialized for this DOM node
    if (!configurator || configurator.dataset.tgInit === 'true') return;
    configurator.dataset.tgInit = 'true';

  // Elements
  const guestSlider = configurator.querySelector('[data-guest-slider]');
  const guestOutput = configurator.querySelector('[data-guest-output]');
  const guestCountDisplays = configurator.querySelectorAll('[data-guest-count]');
  const products = configurator.querySelectorAll('[data-product]');
  const pickupDate = configurator.querySelector('[data-pickup-date]');
  const specialInstructions = configurator.querySelector('[data-special-instructions]');
  const summaryItems = configurator.querySelector('[data-summary-items]');
  const totalDisplays = configurator.querySelectorAll('[data-total]');
  const addToCartBtn = configurator.querySelector('[data-add-to-cart]');
  
  // Preference elements
  const prefSliders = {
    beef: configurator.querySelector('[data-pref-slider="beef"]'),
    chicken: configurator.querySelector('[data-pref-slider="chicken"]'),
    pork: configurator.querySelector('[data-pref-slider="pork"]')
  };
  const prefOutputs = {
    beef: configurator.querySelector('[data-pref-output="beef"]'),
    chicken: configurator.querySelector('[data-pref-output="chicken"]'),
    pork: configurator.querySelector('[data-pref-output="pork"]')
  };
  const prefTotalEl = configurator.querySelector('[data-pref-total]');
  
  // Dietary restriction elements
  const restrictionCheckboxes = configurator.querySelectorAll('[data-restriction]');
  const restrictionCounts = {
    'no-pork': configurator.querySelector('[data-restriction-count="no-pork"]'),
    'no-beef': configurator.querySelector('[data-restriction-count="no-beef"]'),
    'vegetarian': configurator.querySelector('[data-restriction-count="vegetarian"]')
  };

  // State
  let guestCount = parseInt(guestSlider.value);
  let preferences = {
    beef: 40,
    chicken: 30,
    pork: 30
  };
  let restrictions = {
    'no-pork': 0,
    'no-beef': 0,
    'vegetarian': 0
  };

  // Initialize
  function init() {
    bindEvents();
    updatePrefTotal();
    updateRecommendations();
  }

  function bindEvents() {
    // Guest count slider
    guestSlider.addEventListener('input', function() {
      guestCount = parseInt(this.value);
      guestOutput.textContent = guestCount;
      guestCountDisplays.forEach(el => el.textContent = guestCount);
      updateRecommendations();
    });

    // Preference sliders
    Object.keys(prefSliders).forEach(type => {
      prefSliders[type].addEventListener('input', function() {
        preferences[type] = parseInt(this.value);
        prefOutputs[type].textContent = this.value + '%';
        updatePrefTotal();
        updateRecommendations();
      });
    });

    // Dietary restriction checkboxes
    restrictionCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const type = this.dataset.restriction;
        const countInput = restrictionCounts[type];
        
        if (this.checked) {
          countInput.disabled = false;
          countInput.value = countInput.value === '0' ? '1' : countInput.value;
          restrictions[type] = parseInt(countInput.value);
        } else {
          countInput.disabled = true;
          countInput.value = '0';
          restrictions[type] = 0;
        }
        updateRecommendations();
      });
    });

    // Dietary restriction counts
    Object.keys(restrictionCounts).forEach(type => {
      restrictionCounts[type].addEventListener('input', function() {
        const val = Math.max(0, Math.min(guestCount, parseInt(this.value) || 0));
        this.value = val;
        restrictions[type] = val;
        updateRecommendations();
      });
    });

    // Product interactions
    products.forEach(product => {
      const checkbox = product.querySelector('[data-product-checkbox]');
      const qtyInput = product.querySelector('[data-qty-input]');
      const decreaseBtn = product.querySelector('[data-qty-decrease]');
      const increaseBtn = product.querySelector('[data-qty-increase]');

      checkbox.addEventListener('change', function() {
        if (this.checked) {
          const recommended = getRecommendedQty(product);
          qtyInput.value = recommended;
        } else {
          qtyInput.value = 0;
        }
        updateProductSubtotal(product);
        updateSummary();
      });

      qtyInput.addEventListener('change', function() {
        const qty = Math.max(0, parseInt(this.value) || 0);
        this.value = qty;
        checkbox.checked = qty > 0;
        updateProductSubtotal(product);
        updateSummary();
      });

      decreaseBtn.addEventListener('click', function() {
        const current = parseInt(qtyInput.value) || 0;
        const newVal = Math.max(0, current - 1);
        qtyInput.value = newVal;
        checkbox.checked = newVal > 0;
        updateProductSubtotal(product);
        updateSummary();
      });

      increaseBtn.addEventListener('click', function() {
        const current = parseInt(qtyInput.value) || 0;
        qtyInput.value = current + 1;
        checkbox.checked = true;
        updateProductSubtotal(product);
        updateSummary();
      });
    });

    // Add to cart
    addToCartBtn.addEventListener('click', addToCart);
    
    // Pickup date change
    pickupDate.addEventListener('change', updateSummary);
  }

  function updatePrefTotal() {
    const total = preferences.beef + preferences.chicken + preferences.pork;
    const totalSpan = prefTotalEl.querySelector('span');
    const statusEl = prefTotalEl.querySelector('.tailgate__pref-status');
    
    totalSpan.textContent = total + '%';
    
    if (total === 100) {
      statusEl.textContent = '✓';
      statusEl.className = 'tailgate__pref-status tailgate__pref-status--good';
    } else if (total < 100) {
      statusEl.textContent = '(' + (100 - total) + '% unassigned)';
      statusEl.className = 'tailgate__pref-status tailgate__pref-status--warn';
    } else {
      statusEl.textContent = '(' + (total - 100) + '% over)';
      statusEl.className = 'tailgate__pref-status tailgate__pref-status--error';
    }
  }

  function getRecommendedQty(product) {
    const servingSize = parseFloat(product.dataset.servingSize) || 0.5;
    const meatType = product.dataset.meatType || 'other';
    
    // Start with total guests minus vegetarians
    let effectiveGuests = guestCount - restrictions.vegetarian;
    
    // Apply meat-specific restrictions
    if (meatType === 'pork') {
      effectiveGuests -= restrictions['no-pork'];
    } else if (meatType === 'beef') {
      effectiveGuests -= restrictions['no-beef'];
    }
    
    // Don't go below 0
    effectiveGuests = Math.max(0, effectiveGuests);
    
    // Apply preference percentage for meat types
    let multiplier = 1;
    if (meatType === 'beef') {
      multiplier = preferences.beef / 100;
    } else if (meatType === 'chicken') {
      multiplier = preferences.chicken / 100;
    } else if (meatType === 'pork') {
      multiplier = preferences.pork / 100;
    }
    // 'other' (sides, sauces) get full guest count
    
    // Calculate recommended quantity
    let recommended = effectiveGuests * servingSize * multiplier;
    
    // Round up to nearest whole number
    recommended = Math.ceil(recommended);
    
    // Minimum of 1 if there's any demand
    if (recommended > 0 && recommended < 1) {
      recommended = 1;
    }
    
    return recommended;
  }

  function updateRecommendations() {
    products.forEach(product => {
      const checkbox = product.querySelector('[data-product-checkbox]');
      const qtyInput = product.querySelector('[data-qty-input]');
      
      if (checkbox.checked) {
        const recommended = getRecommendedQty(product);
        qtyInput.value = recommended;
        updateProductSubtotal(product);
      }
    });
    updateSummary();
  }

  function updateProductSubtotal(product) {
    const qtyInput = product.querySelector('[data-qty-input]');
    const subtotalEl = product.querySelector('[data-product-subtotal]');
    const price = parseInt(product.dataset.price); // Price in cents
    const qty = parseInt(qtyInput.value) || 0;
    const subtotal = (price * qty) / 100;
    subtotalEl.textContent = formatMoney(subtotal);
  }

  function updateSummary() {
    let total = 0;
    let html = '';
    let hasItems = false;

    products.forEach(product => {
      const checkbox = product.querySelector('[data-product-checkbox]');
      const qtyInput = product.querySelector('[data-qty-input]');
      
      if (checkbox.checked) {
        hasItems = true;
        const title = product.querySelector('.tailgate__product-title').textContent;
        const unit = product.dataset.unit;
        const price = parseInt(product.dataset.price);
        const qty = parseInt(qtyInput.value) || 0;
        const subtotal = (price * qty) / 100;
        total += subtotal;

        html += `
          <div class="tailgate__summary-item">
            <span>${title} (${qty} ${unit}${qty !== 1 ? 's' : ''})</span>
            <span>${formatMoney(subtotal)}</span>
          </div>
        `;
      }
    });

    if (!hasItems) {
      html = '<p class="tailgate__summary-empty">Select items above</p>';
    }

    summaryItems.innerHTML = html;
    totalDisplays.forEach(el => el.textContent = formatMoney(total));

    // Enable/disable button
    const minOrderEl = configurator.querySelector('[data-min-order]');
    const minOrder = minOrderEl ? parseInt(minOrderEl.dataset.minOrder) : 0;
    const hasPickupDate = pickupDate.value !== '';
    addToCartBtn.disabled = !hasItems || !hasPickupDate || total < minOrder;
  }

  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  async function addToCart() {
    const items = [];
    const pickupDateValue = pickupDate.value;
    const instructions = specialInstructions.value.trim();
    
    // Build preference summary
    let prefSummary = `Beef ${preferences.beef}%, Chicken ${preferences.chicken}%, Pork ${preferences.pork}%`;
    let restrictionSummary = [];
    if (restrictions['no-pork'] > 0) restrictionSummary.push(`${restrictions['no-pork']} no pork`);
    if (restrictions['no-beef'] > 0) restrictionSummary.push(`${restrictions['no-beef']} no beef`);
    if (restrictions.vegetarian > 0) restrictionSummary.push(`${restrictions.vegetarian} vegetarian`);

    products.forEach(product => {
      const checkbox = product.querySelector('[data-product-checkbox]');
      const qtyInput = product.querySelector('[data-qty-input]');
      
      if (checkbox.checked) {
        const variantId = parseInt(product.dataset.variantId);
        const qty = parseInt(qtyInput.value) || 0;
        
        if (qty > 0) {
          const properties = {
            'Pickup Date': pickupDateValue,
            'Event Size': `${guestCount} guests`,
            'Group Preferences': prefSummary
          };
          
          if (restrictionSummary.length > 0) {
            properties['Dietary Restrictions'] = restrictionSummary.join(', ');
          }
          
          if (instructions) {
            properties['Special Instructions'] = instructions;
          }

          items.push({
            id: variantId,
            quantity: qty,
            properties: properties
          });
        }
      }
    });

    if (items.length === 0) {
      alert('Please select at least one item.');
      return;
    }

    if (!pickupDateValue) {
      alert('Please select a pickup date.');
      pickupDate.focus();
      return;
    }

    // Disable button during request
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Success - redirect to cart
      window.location.href = '/cart';
      
    } catch (error) {
      console.error('Cart error:', error);
      alert('There was an error adding items to your cart. Please try again.');
      addToCartBtn.disabled = false;
      updateSummary();
    }
  }

  // Start
  init();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-tailgate-configurator]')
      .forEach(initConfigurator);
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when a section is added/edited in the Shopify theme editor
  // (deferred scripts do not re-run on shopify:section:load)
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();